import { Badge } from "@coval/ui/badge"
import { Card, CardContent } from "@coval/ui/card"
import { Input } from "@coval/ui/input"

import {
  getInvitationEmailError,
  parseInvitationEmails,
} from "../utils/invitationEmails"

interface InvitationEmailInputProps {
  emails: string[]
  draft: string
  onEmailsChange: (emails: string[]) => void
  onDraftChange: (draft: string) => void
  disabled: boolean
  invalid: boolean
}

export function InvitationEmailInput({
  emails,
  draft,
  onEmailsChange,
  onDraftChange,
  disabled,
  invalid,
}: InvitationEmailInputProps) {
  const commit = (value: string) => {
    onEmailsChange(parseInvitationEmails([...emails, value]))
    onDraftChange("")
  }

  return (
    <Card className="min-h-32">
      <CardContent className="flex flex-wrap items-center gap-2 p-3">
        {emails.map((email) => (
          <Badge
            key={email.toLowerCase()}
            className="max-w-full"
            variant={getInvitationEmailError([email]) ? "danger" : "outline"}
            dismissLabel={`Remove ${email}`}
            onDismiss={
              disabled
                ? undefined
                : () => onEmailsChange(emails.filter((item) => item !== email))
            }
          >
            <span className="min-w-0 truncate" title={email}>
              {email}
            </span>
          </Badge>
        ))}
        <Input
          id="invite-email"
          type="text"
          inputMode="email"
          autoComplete="off"
          aria-label="Email addresses"
          aria-describedby="invite-email-help"
          aria-invalid={invalid}
          placeholder={
            emails.length ? "Add another email…" : "teammate@company.com"
          }
          value={draft}
          onChange={(event) => {
            const value = event.target.value
            if (/[\s,;]/.test(value)) {
              commit(value)
            } else {
              onDraftChange(value)
            }
          }}
          onBlur={() => {
            if (draft.trim()) {
              commit(draft)
            }
          }}
          onKeyDown={(event) => {
            if (event.nativeEvent.isComposing) {
              return
            }
            if (["Enter", ",", ";", " "].includes(event.key)) {
              event.preventDefault()
              commit(draft)
            } else if (event.key === "Backspace" && !draft && emails.length) {
              event.preventDefault()
              onEmailsChange(emails.slice(0, -1))
              onDraftChange(emails[emails.length - 1])
            }
          }}
          disabled={disabled}
          className="min-w-40 flex-1 border-0 px-0"
        />
      </CardContent>
    </Card>
  )
}
